import { ChangeEvent, Dispatch, SetStateAction } from 'react';
import FormGroup from '../../../components/FormGroup';
import Input from '../../../components/Input';
import PasswordInputFormGroup from '../../../components/PasswordInputFormGroup';
import { GetErrorMessageByFieldNameType } from '../../../hooks/useErrors';

interface ChangePasswordViewInterface {
  validationCode: string;
  setValidationCode: Dispatch<SetStateAction<string>>;
  getErrorMessageByFieldName: GetErrorMessageByFieldNameType;
  password: string;
  handlePasswordChange: (event: ChangeEvent<HTMLInputElement>) => void;
  passwordConfirmation: string;
  handlePasswordConfirmationChange: (event: ChangeEvent<HTMLInputElement>) => void;
}

export default function ChangePasswordView({
  validationCode,
  setValidationCode,
  getErrorMessageByFieldName,
  password,
  handlePasswordChange,
  passwordConfirmation,
  handlePasswordConfirmationChange,
}: ChangePasswordViewInterface) {
  return (
    <>
      <FormGroup>
        <label htmlFor="login">Código</label>
        <Input
          placeholder="Informe o código enviado ao seu e-mail"
          value={validationCode}
          onChange={(event) => setValidationCode(event.target.value)}
          autoComplete="new-password"
        />
      </FormGroup>
      <PasswordInputFormGroup
        label='Senha'
        value={password}
        onChange={handlePasswordChange}
        error={getErrorMessageByFieldName('password')}
      />
      <PasswordInputFormGroup
        label='Confirme a senha'
        value={passwordConfirmation}
        onChange={handlePasswordConfirmationChange}
        error={getErrorMessageByFieldName('passwordConfirmation')}
      />
    </>
  );
}
